import { useId } from 'react';
import { sanitizeCss } from './sanitizeCss';

const CLASS_NAME_RE = /\/\*\s*([\w-]+)\s*\*\//;

// Scope author-supplied CSS to a single section by rewriting its base class to
// a unique per-mount class name. Returns the class to add to the rendering's
// outer wrapper, and the sanitised, scoped CSS string ready for injection via
// <style dangerouslySetInnerHTML={{ __html: scopedAdditionalCss }} />.
export function useAdditionalCss(
  additional_css: string | undefined,
  renderingName = 'Rendering',
): { uniqueClass: string | undefined; scopedAdditionalCss: string | undefined } {
  const uid = useId().replace(/:/g, '');

  const baseClass = additional_css ? CLASS_NAME_RE.exec(additional_css)?.[1] : undefined;

  if (additional_css && !baseClass) {
    console.error(`${renderingName}: additional_css provided but no base class comment found (e.g. /* my-class */). Skipping additional_css.`);
  }

  const uniqueClass = baseClass ? `${baseClass}-${uid}` : undefined;

  const scopedAdditionalCss =
    additional_css && baseClass && uniqueClass
      ? sanitizeCss(additional_css.replaceAll(`.${baseClass}`, `.${uniqueClass}`))
      : undefined;

  return { uniqueClass, scopedAdditionalCss };
}
